<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template #no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök font</em>
        </template>
        <template #option="{ label, font_family }">
            <span :style="{ fontFamily: font_family }">{{ label }}</span>
        </template>
        <template #selected-option-container="{ option }">
            <div class="vs__selected w-100">
                <span :style="{ fontFamily: option.font_family }">{{ option.label }}</span>
            </div>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'PaymentMethodFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];
            await BackendRepository.getEcardTemplateFonts().then((res) => {
                options = res.map((item) => ({
                    label: item.name,
                    ...item,
                }));
            });

            return options;
        },
    },
};
</script>
